"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _find = _interopRequireDefault(require("lodash/find"));
var _pickBy = _interopRequireDefault(require("lodash/pickBy"));
var _keys = _interopRequireDefault(require("lodash/keys"));
var _filter = _interopRequireDefault(require("lodash/filter"));
var _proj = require("ol/proj");
var _Tile = _interopRequireDefault(require("ol/layer/Tile.js"));
var _TileJSON = _interopRequireDefault(require("ol/source/TileJSON"));
var _mapState = require("../../hooks/mapState");
var _layers = require("../../hooks/queries/layers");
var _map = require("./map");
var _helpers = require("../../lib/helpers");
var _lineMap = _interopRequireDefault(require("../../../utilities/line-map"));
var _LayerModal = _interopRequireDefault(require("./LayerModal"));
var _lines = _interopRequireDefault(require("./openlayers/lines"));
var _mileposts = _interopRequireDefault(require("./openlayers/mileposts"));
var _stations = _interopRequireDefault(require("./openlayers/stations"));
var _nonpublicStops = _interopRequireDefault(require("./openlayers/nonpublicStops"));
var _facilities = _interopRequireDefault(require("./openlayers/facilities"));
var _crossings = _interopRequireDefault(require("./openlayers/crossings"));
var _trains = _interopRequireWildcard(require("./openlayers/trains"));
var _equipment = _interopRequireDefault(require("./openlayers/equipment"));
var _tasks = _interopRequireDefault(require("./openlayers/tasks"));
var _incident = _interopRequireDefault(require("./openlayers/incident"));
var _constants = require("../../lib/constants");
var _freeSolidSvgIcons = require("@fortawesome/free-solid-svg-icons");
var _reactFontawesome = require("@fortawesome/react-fontawesome");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
// openlayers map

//import Transition from 'react-transition-group/CSSTransitionGroup';

// layers
// Static
//
// // Playback
//import Radar from './openlayers/radar';
// import ol from 'openlayers';
// import { UNSELECTED } from '../../../store/selected/selected';
// import { usersSelector } from '../../../../apps/web/src/store/selectors';
// // Layer map
var layerMap = {
  trains: _trains["default"],
  facilities: _facilities["default"],
  mileposts: _mileposts["default"],
  stations: _stations["default"],
  nonpublicStops: _nonpublicStops["default"],
  equipment: _equipment["default"],
  lines: _lines["default"],
  tasks: _tasks["default"],
  incident: _incident["default"],
  crossings: _crossings["default"]
};
var GeoMap = function GeoMap(props) {
  //console.log(mapTilerAPIKey)
  var mapRef = (0, _react.useRef)();
  var overlayRef = (0, _react.useRef)();
  var _useMapState = (0, _mapState.useMapState)(),
    mapState = _useMapState.mapState,
    unselect = _useMapState.unselect,
    newSetSelected = _useMapState.newSetSelected,
    newSetHovered = _useMapState.newSetHovered,
    setTrains = _useMapState.setTrains;
  var selected = mapState.selected,
    hovered = mapState.hovered,
    playback = mapState.playback;
  // denny 9/29/23 the props below are free from redux
  var showLegend = props.showLegend,
    testLayer = props.testLayer;
  // console.log('test layer: ', testLayer)

  var Legend = function Legend(_ref) {
    var layers = _ref.layers,
      visible = _ref.visible;
    // figure out what to do with this when you need to port this map to the other apps
    // return <div className={`legend ${visible ? "visible" : ""}`}>
    // 	{
    // 		layers.map(layer => {
    // 			return <div key={layer} className="legend-detail" >
    // 				{layerMap[layer].getLegend()}
    // 			</div>;
    // 		})
    // 	}
    // </div>;

    return /*#__PURE__*/_react["default"].createElement("div", {
      className: "legend ".concat(showLegend ? "visible" : "")
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "legend-detail"
    }, layerMap['trains'].getLegend()));
  };
  var zoomToMe = function zoomToMe() {
    var locationSuccess = function locationSuccess(position) {
      var _position$coords = position.coords,
        longitude = _position$coords.longitude,
        latitude = _position$coords.latitude;
      var myLocationCoords = (0, _proj.transform)([longitude, latitude], "EPSG:4326", "EPSG:900913");
      _map.map.getView().animate({
        zoom: 12
      }, {
        center: myLocationCoords
      });
    };
    var locationError = function locationError(error) {
      console.log('error: ', error);
    };
    navigator.geolocation.getCurrentPosition(locationSuccess, locationError);
  };
  var resetZoom = function resetZoom() {
    _map.map.getView().animate({
      zoom: 9
    }, {
      center: _map.centerCoordinates
    });
    //map.getView().setCenter([-71.1, 42.3]);
  };

  _map.map.on('pointermove', function (e) {
    var feature = _map.map.forEachFeatureAtPixel(e.pixel, function (feature, layer) {
      var featInfo = {
        layer: layer.get("name"),
        feature: feature
      };
      return featInfo;
    }, {
      layerFilter: function layerFilter(layer) {
        return layer.get("name") === 'stations';
      }
    });
    if (feature && feature.layer === 'stations') {
      var _feature$feature$getP = feature.feature.getProperties(),
        stopId = _feature$feature$getP.stop_id,
        vehicle_type = _feature$feature$getP.vehicle_type;
      if (vehicle_type) {
        newSetHovered({
          type: 'stop',
          id: feature.feature.id_
        });
        return;
      }
    } else {
      if (hovered) {
        newSetHovered({
          type: null,
          id: null
        });
        return;
      }
    }
  });
  _map.map.on('click', function (e) {
    console.log('click event: ', e);
    var overlayRef = overlayRef === null || overlayRef === void 0 ? void 0 : overlayRef.current;
    var originalEvent = e.originalEvent,
      browserEvent = e.browserEvent;
    if (originalEvent.target.classList && originalEvent.target.classList.contains('allow-click')) {
      return;
    } else {
      // Handle clicks inside the popover
      if (originalEvent && overlayRef && overlayRef.contains(originalEvent.target) || browserEvent && overlayRef.contains(browserEvent.target)) {
        //cutoff for clicks inside popover
        //timeout to delay execution until React is done
        //i.e. so component doesn't become unmounted
        console.log("cutting off");
        unselect();
        // setTimeout(() => props.deselect());
        return;
      }
    }

    // Get feature from map
    var feature = _map.map.forEachFeatureAtPixel(e.pixel, function (feature, layer) {
      return {
        layer: layer.get("name"),
        feature: feature
      };
    });
    // deselect nonpublic stops if you click anywhere else while a nonpublic stop is selected

    if (!feature && selected.type === 'nonpublicStop') {
      unselect();
    }
    console.log('feature: ', feature);
    var overlayContent = null;
    if (feature) {
      // Get props from feature
      var featureProps = feature.feature.getProperties();
      console.log('feature props: ', featureProps);

      // let's select this in the store & cutoff early
      switch (feature.layer) {
        case "trains":
          {
            var _selected$entireTrain;
            if (((_selected$entireTrain = selected.entireTrainObj) === null || _selected$entireTrain === void 0 ? void 0 : _selected$entireTrain.vehicleId) === featureProps.vehicleId) {
              return unselect();
            }
            newSetSelected({
              id: featureProps.trip_short_name ? featureProps.trip_short_name : null,
              vehicle: featureProps.vehicle,
              type: 'train',
              tripShortName: featureProps.trip_short_name,
              vehicle_status: featureProps.vehicle_status,
              entireTrainObj: featureProps
            });
            if (featureProps !== null && featureProps !== void 0 && featureProps.vehicleId) {
              (0, _helpers.zoomToTrain)(_trains.layer, _map.map, feature.feature.id_);
            }
            return;
          }
        case "mileposts":
          newSetSelected({
            id: featureProps.milepostId,
            type: 'milepost'
          });
          return;
        case "facilities":
          newSetSelected({
            id: featureProps.facility_id,
            type: 'facility'
          });
          return;
        case "stations":
          newSetSelected({
            id: feature.feature.id_,
            type: 'station',
            vehicleType: (featureProps === null || featureProps === void 0 ? void 0 : featureProps.vehicle_type) || null
          });
          return;
        case "nonpublicStops":
          newSetSelected({
            id: featureProps.Identifier,
            type: 'nonpublicStop'
          });
          return;
        case "crossings":
          newSetSelected({
            id: feature.feature.id_,
            type: "crossing"
          });
          return;
        case "equipment":
          newSetSelected({
            id: featureProps.equipment.equipmentId,
            type: 'equipment'
          });
          return;
        case "line":
          var name = _lineMap["default"][featureProps.name] ? _lineMap["default"][featureProps.name] : featureProps.name;
          var location = (0, _find["default"])(props.locations, {
            name: name,
            locationTypeId: 3
          });
          if (location) {
            newSetSelected({
              type: 'route',
              id: location.locationId
            });
          }
          return;
        case "tasks":
          newSetSelected({
            type: 'tasks',
            ids: featureProps.features.map(function (f) {
              return f.get("task").taskId;
            }),
            position: feature.feature.getGeometry().getCoordinates()
          });
          return;
      }
    }
  });
  var getOverlay = function getOverlay(selected) {
    var resetSelection = function resetSelection() {
      unselect();
      // props.setSelected(UNSELECTED)
    };

    var currentZoom = _map.map.getView().getZoom();
    if (selected.type === 'nonpublicStop' && currentZoom < _constants.INTERLOCKING_ZOOM) {
      resetSelection();
      return null;
    }
    switch (selected.type) {
      case "train":
        {
          return _trains["default"].getOverlay(selected, props.newTrains, props.filter,
          // Don't allow tagging if we're in playback mode
          playback.timestamp ? false : props.enableTagging);
        }
      case "equipment":
        console.log('selected some equipment');
      //return Equipment.getOverlay(selected.id, props.equipment);
      case "tasks":
        console.log('selected a task');
      // const tasks = filter(props.tasks, (task) => {
      // 	return selected.ids.includes(task.taskId)
      // });
      // return Tasks.getOverlay(tasks, selected.position, props.taskButtonComponent);
      case "station":
        return _stations["default"].getOverlay(selected.id, props.stations);
      case "facility":
        return _facilities["default"].getOverlay(selected.id, props.facilities);
      case "nonpublicStop":
        return _nonpublicStops["default"].getOverlay(selected.id, props.nonpublicStops);
      case "crossing":
        return _crossings["default"].getOverlay(selected.id, props.crossings);
      default:
        return null;
    }
  };
  var getHoverOverlay = function getHoverOverlay(hovered) {
    switch (hovered === null || hovered === void 0 ? void 0 : hovered.type) {
      case "stop":
        return _stations["default"].getHoverOverlay(hovered.id, props.stations);
      default:
        return null;
    }
  };
  var renderOverlay = function renderOverlay(hovered, selected) {
    if (hovered && hovered.type && !selected.type) {
      return getHoverOverlay(hovered);
    } else if (selected && selected.type) {
      return getOverlay(selected);
    }
    // return null
  };

  // This may have some use for comm and event manager later...
  // const getLegendLayers = (layers) => {
  // 	const legendLayers =
  // 		pickBy(layers, (v, k) => v && k != "all" && layerMap[k] && layerMap[k].getLegend);
  // 	return keys(legendLayers);
  // }

  var handleResize = function handleResize() {
    _map.map.updateSize();
  };
  (0, _react.useEffect)(function () {
    _map.map.setTarget(mapRef.current);

    // init overlay
    _map.overlay.setElement(overlayRef.current);
    _map.map.addOverlay(_map.overlay);

    //event handle for click outside
    return function () {
      _map.map.removeEventListener('click');
    };
  }, []);
  (0, _react.useEffect)(function () {
    for (var layer in layerMap) {
      if (layer !== 'trains') {
        layerMap[layer].handleUpdate(props);
      }
    }
  }, [props.selected, props.hovered, props.lines, props.trains, props.facilities, props.equipment, props.nonpublicStops]);
  (0, _react.useEffect)(function () {
    var _props$newTrains, _props$newTrains$feat;
    // props.trains for legacy handle update...

    // filter out all ghost trains except for when a ghost train is selected
    var renderNow = false;
    var filterGhosts = props === null || props === void 0 ? void 0 : (_props$newTrains = props.newTrains) === null || _props$newTrains === void 0 ? void 0 : (_props$newTrains$feat = _props$newTrains.features) === null || _props$newTrains$feat === void 0 ? void 0 : _props$newTrains$feat.filter(function (t) {
      // if (t.properties?.vehicle_status === 'GHOST' ){
      // 	if (selected?.tripShortName === t.properties.trip_short_name) {
      // 		// found the one ghost train i selected
      // 		renderNow = true
      // 		return true
      // 	}
      // 	// dont return any ghost trains at all
      // 	return false
      // }
      return true;
    });
    if (props.newTrains) {
      props.newTrains.features = filterGhosts;
    }
    layerMap.trains.handleUpdate(props.newTrains, renderNow, false, playback.isPlaying, selected);
  }, [props.newTrains, selected]);

  // useEffect(() => {
  // 	if (selected?.type === 'train' && selected.vehicleId.includes('ghost')) {
  // 		const filterGhosts = props?.newTrains?.features?.filter((t) => {
  // 			if (t.properties?.vehicle_status === 'GHOST' ){
  // 				if (selected?.tripShortName === t.properties.trip_short_name) {
  // 					// found the one ghost train i selected
  // 					console.log('is this it? ', t, selected)
  // 					return true
  // 				}
  // 				// dont return any ghost trains at all
  // 				return false
  // 			}
  // 			return true
  // 		})

  // 		const updatedTrains = {...props.newTrains, features: filterGhosts }
  // 		console.log('setting updated trains into state... ')
  // 		setTrains(updatedTrains)

  // 		//layerMap.trains.immediateUpdate(filterGhosts, selected)
  // 	}
  // }, [selected])

  // PUT THIS BACK IN FOR THE LAYER SWAPPING STUFF
  // useEffect(() => {
  // 	map.getLayers().forEach((layer) => {
  // 		if (layer.get('name') === 'tiles'){
  // 			map.removeLayer(layer)
  // 		}
  // 	})
  // 	const tileLayer = new TileLayer({
  // 		// source: new OSM(),
  // 		source: new TileJSON({
  // 			// crossOrigin: null,
  // 			url: testLayer,
  // 			tileSize: 512,
  // 			crossOrigin: 'anonymous',

  // 		}),
  // 		name: 'tiles',
  // 		zIndex: 10
  // 	});
  // 	map.addLayer(tileLayer)
  // }, [testLayer])

  return /*#__PURE__*/_react["default"].createElement("div", {
    id: "geo-map"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      backgroundColor: '#fff'
    },
    className: "map",
    id: "map",
    ref: mapRef
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "zoom-button-div",
    onClick: function onClick() {
      resetZoom();
    }
  }, /*#__PURE__*/_react["default"].createElement(_reactFontawesome.FontAwesomeIcon, {
    icon: _freeSolidSvgIcons.faArrowsAlt
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: "zoom-to-me-div",
    onClick: function onClick() {
      zoomToMe();
    }
  }, /*#__PURE__*/_react["default"].createElement(_reactFontawesome.FontAwesomeIcon, {
    icon: _freeSolidSvgIcons.faUserCircle
  }))), /*#__PURE__*/_react["default"].createElement("div", {
    ref: overlayRef
  }, renderOverlay(hovered, selected)), /*#__PURE__*/_react["default"].createElement(Legend
  // layers={getLegendLayers(layers)}
  , {
    visible: showLegend
  }));
};
var _default = GeoMap;
exports["default"] = _default;